<script>
  import _ from 'underscore'
  import ItemPage from '../components/ItemPage.vue'
  import ItemList from '../components/ItemList.vue'
  import PageChooser from '../components/PageChooser.vue'
  import Status from '../components/Status.vue'
  import { item, externalItem } from '../components/Item.vue'
  import Vol01 from './Vol01.vue'
  import Vol02 from './Vol02.vue'
  import Vol03 from './Vol03.vue'
  import Vol04 from './Vol04.vue'
  import Vol05 from './Vol05.vue'
  import Vol06 from './Vol06.vue'
  import Jewel01 from './Jewel01.vue'
  import Jewel02 from './Jewel02.vue'
  import Jewel03 from './Jewel03.vue'
  import Jewel04 from './Jewel04.vue'
  import Jewel05 from './Jewel05.vue'
  import Jewel06 from './Jewel06.vue'
  import PriTama01 from './PriTama01.vue'
  import PriTama02 from './PriTama02.vue'
  import PriTama03 from './PriTama03.vue'
  import PriTama04 from './PriTama04.vue'
  import PriTama05 from './PriTama05.vue'
  import PriTama06 from './PriTama06.vue'
  import PAF01 from './PAF01.vue'
  import Promo2019_Events from './Promo2019_Events.vue'


  /** @typedef {import('../components/Item.vue').ItemInfo} ItemInfo */
  /** @type {ItemInfo[]} */ const itemsVol01 = Vol01.data().items
  /** @type {ItemInfo[]} */ const itemsVol02 = Vol02.data().items
  /** @type {ItemInfo[]} */ const itemsVol03 = Vol03.data().items
  /** @type {ItemInfo[]} */ const itemsVol04 = Vol04.data().items
  /** @type {ItemInfo[]} */ const itemsVol05 = Vol05.data().items
  /** @type {ItemInfo[]} */ const itemsVol06 = Vol06.data().items
  /** @type {ItemInfo[]} */ const itemsJewel01 = Jewel01.data().items
  /** @type {ItemInfo[]} */ const itemsJewel02 = Jewel02.data().items
  /** @type {ItemInfo[]} */ const itemsJewel03 = Jewel03.data().items
  /** @type {ItemInfo[]} */ const itemsJewel04 = Jewel04.data().items
  /** @type {ItemInfo[]} */ const itemsJewel05 = Jewel05.data().items
  /** @type {ItemInfo[]} */ const itemsJewel06 = Jewel06.data().items
  /** @type {ItemInfo[]} */ const itemsPriTama01 = PriTama01.data().items
  /** @type {ItemInfo[]} */ const itemsPriTama02 = PriTama02.data().items
  /** @type {ItemInfo[]} */ const itemsPriTama03 = PriTama03.data().items
  /** @type {ItemInfo[]} */ const itemsPriTama04 = PriTama04.data().items
  /** @type {ItemInfo[]} */ const itemsPriTama05 = PriTama05.data().items
  /** @type {ItemInfo[]} */ const itemsPriTama06 = PriTama06.data().items
  /** @type {ItemInfo[]} */ const itemsPAF01 = PAF01.data().items
  /** @type {ItemInfo[]} */ const itemsPromo2019_Events = Promo2019_Events.data().items


  export default {
    components: { ItemPage, ItemList, PageChooser, Status },

    data () {
      return {
        date : '2022-03-15',
        items: [

          // [NOTE] プリリズDMFチャンネル ER
          // ================================================================================

          item({
            collection  : 'PRDMFCh',
            id          : 'PAF02-01',
            rare        : 'ER',
            name        : 'じょうねつのシンフォニアドレス',
            imgUrl      : '/images/items/PAF02-01.png',
            kind        : 'ワンピース',
            color       : '赤',
            brand       : '',
            type        : 'PR',
            point       : 2000,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PRDMFCh',
            id          : 'PAF02-02',
            rare        : 'ER',
            name        : 'はじまりのシンフォニアブーツ',
            imgUrl      : '/images/items/PAF02-02.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 950,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PRDMFCh',
            id          : 'PAF02-03',
            rare        : 'ER',
            name        : 'えいえんなるシンフォニアティアラ',
            imgUrl      : '/images/items/PAF02-03.png',
            kind        : 'ヘアアクセ',
            color       : '銀',
            brand       : '',
            type        : 'PR',
            point       : 950,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PRDMFCh',
            rare        : 'ER',
          }),


          item({
            collection  : 'PRDMFCh',
            id          : 'PAF02-04',
            rare        : 'ER',
            name        : 'ほしぞらのシンフォニアドレス',
            imgUrl      : '/images/items/PAF02-04.png',
            kind        : 'ワンピース',
            color       : '黒',
            brand       : '',
            type        : 'PR',
            point       : 2000,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRDMFCh',
            rare        : 'ER',
          }),
          item({
            collection  : 'PRDMFCh',
            rare        : 'ER',
          }),
          item({
            collection  : 'PRDMFCh',
            rare        : 'ER',
          }),


          item({
            collection  : 'PRDMFCh',
            id          : 'PAF02-05',
            rare        : 'ER',
            name        : 'しんぴのシンフォニアドレス',
            imgUrl      : '/images/items/PAF02-05.png',
            kind        : 'ワンピース',
            color       : '紫',
            brand       : '',
            type        : 'PR',
            point       : 2000,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PRDMFCh',
            id          : 'PAF02-06',
            rare        : 'ER',
            name        : 'ゆめみるシンフォニアパンプス',
            imgUrl      : '/images/items/PAF02-06.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : '',
            type        : 'PR',
            point       : 950,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PRDMFCh',
            id          : 'PAF02-07',
            rare        : 'ER',
            name        : 'よろこびのシンフォニアカチューシャ',
            imgUrl      : '/images/items/PAF02-07.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : '',
            type        : 'PR',
            point       : 950,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PRDMFCh',
            rare        : 'ER',
          }),


          item({
            collection  : 'PRDMFCh',
            id          : 'PAF02-10',
            rare        : 'ER',
            name        : 'めざめのシンフォニアドレス',
            imgUrl      : '/images/items/PAF02-10.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 2000,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRDMFCh',
            rare        : 'ER',
          }),
          item({
            collection  : 'PRDMFCh',
            rare        : 'ER',
          }),
          item({
            collection  : 'PRDMFCh',
            rare        : 'ER',
          }),


          item({
            collection  : 'PRDMFCh',
            id          : 'PAF02-08',
            rare        : 'ER',
            name        : 'はばたきのシンフォニアトップス',
            imgUrl      : '/images/items/PAF02-08.png',
            kind        : 'トップス',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 1100,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRDMFCh',
            id          : 'PAF02-09',
            rare        : 'ER',
            name        : 'ゆうきのシンフォニアスカート',
            imgUrl      : '/images/items/PAF02-09.png',
            kind        : 'ボトムス',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 1050,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRDMFCh',
            rare        : 'ER',
          }),
          item({
            collection  : 'PRDMFCh',
            rare        : 'ER',
          }),


          // [NOTE] プリリズDMFチャンネル PR
          // ================================================================================

          item({
            collection  : 'PRDMFCh',
            id          : 'PAF02-11',
            rare        : 'PR',
            name        : 'プリズミー☆スターベスト',
            imgUrl      : '/images/items/PAF02-11.png',
            kind        : 'トップス',
            color       : '黄',
            brand       : '',
            type        : 'PR',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRDMFCh',
            id          : 'PAF02-12',
            rare        : 'PR',
            name        : 'プリズミー☆スターショーパン',
            imgUrl      : '/images/items/PAF02-12.png',
            kind        : 'ボトムス',
            color       : '黄',
            brand       : '',
            type        : 'PR',
            point       : 900,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRDMFCh',
            rare        : 'PR',
          }),
          item({
            collection  : 'PRDMFCh',
            rare        : 'PR',
          }),


          item({
            collection  : 'PRDMFCh',
            id          : 'PAF02-13',
            rare        : 'PR',
            name        : 'プリズミー☆リボンベスト',
            imgUrl      : '/images/items/PAF02-13.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRDMFCh',
            id          : 'PAF02-14',
            rare        : 'PR',
            name        : 'プリズミー☆リボンスカート',
            imgUrl      : '/images/items/PAF02-14.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 900,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRDMFCh',
            id          : 'PAF02-15',
            rare        : 'PR',
            name        : 'ラインリボンロングブーツ',
            imgUrl      : '/images/items/PAF01-13.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : '',
            type        : 'PR',
            point       : 850,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PRDMFCh',
            rare        : 'PR',
          }),


          item({
            collection  : 'PRDMFCh',
            id          : 'PAF02-16',
            rare        : 'PR',
            name        : 'DCピュリティルージュジャケット',
            imgUrl      : '/images/items/PAF02-16.png',
            kind        : 'トップス',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 900,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRDMFCh',
            id          : 'PAF02-17',
            rare        : 'PR',
            name        : 'DCピュリティベルトショーパン',
            imgUrl      : '/images/items/PAF02-17.png',
            kind        : 'ボトムス',
            color       : '黒',
            brand       : '',
            type        : 'PR',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRDMFCh',
            rare        : 'PR',
          }),
          item({
            collection  : 'PRDMFCh',
            rare        : 'PR',
          }),


          item({
            collection  : 'PRDMFCh',
            id          : 'PAF02-18',
            rare        : 'PR',
            name        : 'DCピュリティライン&ジャケット',
            imgUrl      : '/images/items/PAF02-18.png',
            kind        : 'トップス',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 900,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRDMFCh',
            id          : 'PAF02-19',
            rare        : 'PR',
            name        : 'DCピュリティミニスカ',
            imgUrl      : '/images/items/PAF02-19.png',
            kind        : 'ボトムス',
            color       : '黒',
            brand       : '',
            type        : 'PR',
            point       : 800,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRDMFCh',
            rare        : 'PR',
          }),
          item({
            collection  : 'PRDMFCh',
            rare        : 'PR',
          }),


          item({
            collection  : 'PRDMFCh',
            id          : 'PAF02-20',
            rare        : 'PR',
            name        : 'DCピュリティゼブラ&ジャケット',
            imgUrl      : '/images/items/PAF02-20.png',
            kind        : 'トップス',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 900,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRDMFCh',
            id          : 'PAF02-21',
            rare        : 'PR',
            name        : 'DCピュリティラインショーパン',
            imgUrl      : '/images/items/PAF02-21.png',
            kind        : 'ボトムス',
            color       : '黒',
            brand       : '',
            type        : 'PR',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRDMFCh',
            id          : 'PAF02-22',
            rare        : 'PR',
            name        : 'DCピュリティブーツ',
            imgUrl      : '/images/items/PAF02-22.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : '',
            type        : 'PR',
            point       : 850,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] プリリズDMFチャンネル SR
          // ================================================================================

          item({
            collection  : 'PRDMFCh',
            id          : 'PAF02-23',
            rare        : 'SR',
            name        : 'MARsシャイニーリボントップス',
            imgUrl      : '/images/items/PAF02-23.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRDMFCh',
            id          : 'PAF02-24',
            rare        : 'SR',
            name        : 'MARsシャイニーピンクパニエ',
            imgUrl      : '/images/items/PAF02-24.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRDMFCh',
            id          : 'PAF02-25',
            rare        : 'SR',
            name        : 'MARsシャイニーロングブーツ',
            imgUrl      : '/images/items/PAF02-25.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRDMFCh',
            rare        : 'SR',
          }),


          item({
            collection  : 'PRDMFCh',
            id          : 'PAF02-26',
            rare        : 'SR',
            name        : 'MARsシャイニースタートップス',
            imgUrl      : '/images/items/PAF02-26.png',
            kind        : 'トップス',
            color       : '水',
            brand       : '',
            type        : 'PR',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRDMFCh',
            id          : 'PAF02-27',
            rare        : 'SR',
            name        : 'MARsシャイニーブルーショーパン',
            imgUrl      : '/images/items/PAF02-27.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : '',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRDMFCh',
            rare        : 'SR',
          }),
          item({
            collection  : 'PRDMFCh',
            rare        : 'SR',
          }),


          item({
            collection  : 'PRDMFCh',
            id          : 'PAF02-28',
            rare        : 'SR',
            name        : 'MARsシャイニーハートトップス',
            imgUrl      : '/images/items/PAF02-28.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : '',
            type        : 'PR',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRDMFCh',
            id          : 'PAF02-29',
            rare        : 'SR',
            name        : 'MARsシャイニーパープルスカート',
            imgUrl      : '/images/items/PAF02-29.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : '',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRDMFCh',
            rare        : 'SR',
          }),
          item({
            collection  : 'PRDMFCh',
            rare        : 'SR',
          }),


          item({
            collection  : 'PRDMFCh',
            id          : 'PAF02-39',
            rare        : 'SR',
            name        : 'ダンシングキャットワンピ',
            imgUrl      : '/images/items/PAF02-39.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRDMFCh',
            id          : 'PAF02-40',
            rare        : 'SR',
            name        : 'ダンシングハピネスシューズ',
            imgUrl      : '/images/items/PAF02-40.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRDMFCh',
            rare        : 'SR',
          }),
          item({
            collection  : 'PRDMFCh',
            rare        : 'SR',
          }),


          item({
            collection  : 'PRDMFCh',
            id          : 'PAF02-44',
            rare        : 'SR',
            name        : 'ダンスバトラージャケット',
            imgUrl      : '/images/items/PAF02-44.png',
            kind        : 'トップス',
            color       : '黒',
            brand       : '',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRDMFCh',
            id          : 'PAF02-45',
            rare        : 'SR',
            name        : 'ダンスバトラーロングパンツ',
            imgUrl      : '/images/items/PAF02-45.png',
            kind        : 'ボトムス',
            color       : '黒',
            brand       : '',
            type        : 'PR',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRDMFCh',
            id          : 'PAF02-46',
            rare        : 'SR',
            name        : 'ダンスバトラーシューズ',
            imgUrl      : '/images/items/PAF02-46.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : '',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRDMFCh',
            rare        : 'SR',
          }),


          item({
            collection  : 'PRDMFCh',
            id          : 'PAF02-30',
            rare        : 'SR',
            name        : 'ストロベリーアイドルトップス',
            imgUrl      : '/images/items/PAF02-30.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : '',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRDMFCh',
            id          : 'PAF02-31',
            rare        : 'SR',
            name        : 'ストロベリーアイドルパニエ',
            imgUrl      : '/images/items/PAF02-31.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : '',
            type        : 'PR',
            point       : 750,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRDMFCh',
            id          : 'PAF02-32',
            rare        : 'SR',
            name        : 'ストロベリーアイドルブーツ',
            imgUrl      : '/images/items/PAF02-32.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : '',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRDMFCh',
            rare        : 'SR',
          }),


          item({
            collection  : 'PRDMFCh',
            id          : 'PAF02-33',
            rare        : 'SR',
            name        : 'レモネードアイドルベスト',
            imgUrl      : '/images/items/PAF02-33.png',
            kind        : 'トップス',
            color       : '黄',
            brand       : '',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRDMFCh',
            id          : 'PAF02-34',
            rare        : 'SR',
            name        : 'レモネードアイドルかぼちゃパンツ',
            imgUrl      : '/images/items/PAF02-34.png',
            kind        : 'ボトムス',
            color       : '黄',
            brand       : '',
            type        : 'PR',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRDMFCh',
            id          : 'PAF02-35',
            rare        : 'SR',
            name        : 'レモネードアイドルショートブーツ',
            imgUrl      : '/images/items/PAF02-35.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : '',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRDMFCh',
            rare        : 'SR',
          }),


          item({
            collection  : 'PRDMFCh',
            id          : 'PAF02-36',
            rare        : 'SR',
            name        : 'ブルーベリーアイドルジャケット',
            imgUrl      : '/images/items/PAF02-36.png',
            kind        : 'トップス',
            color       : '青',
            brand       : '',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRDMFCh',
            id          : 'PAF02-37',
            rare        : 'SR',
            name        : 'ブルーベリーアイドルミニスカ',
            imgUrl      : '/images/items/PAF02-37.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : '',
            type        : 'PR',
            point       : 750,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRDMFCh',
            id          : 'PAF02-38',
            rare        : 'SR',
            name        : 'ブルーベリーアイドルブーツ',
            imgUrl      : '/images/items/PAF02-38.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : '',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRDMFCh',
            rare        : 'SR',
          }),


          item({
            collection  : 'PRDMFCh',
            id          : 'PAF02-41',
            rare        : 'SR',
            name        : 'HIPHOPカジュアルちびT',
            imgUrl      : '/images/items/PAF02-41.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : '',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRDMFCh',
            id          : 'PAF02-42',
            rare        : 'SR',
            name        : 'HIPHOPダンシングパンツ',
            imgUrl      : '/images/items/PAF02-42.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRDMFCh',
            id          : 'PAF02-43',
            rare        : 'SR',
            name        : 'HIPHOPパターンスニーカー',
            imgUrl      : '/images/items/PAF02-43.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : '',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRDMFCh',
            rare        : 'SR',
          }),


          // [NOTE] プリリズDMFチャンネル R
          // ================================================================================



          // [NOTE] ドリームパレードチャンネル ER
          // ================================================================================

          item({
            collection  : 'DreamParadeCh',
            id          : 'PAF02-47',
            rare        : 'ER',
            name        : 'ドリームパレードプリンセスドレス',
            imgUrl      : '/images/items/PAF02-47.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 2000,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DreamParadeCh',
            id          : 'PAF02-48',
            rare        : 'ER',
            name        : 'ドリームパレードプリンセスシューズ',
            imgUrl      : '/images/items/PAF02-48.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 950,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DreamParadeCh',
            id          : 'PAF02-49',
            rare        : 'ER',
            name        : 'ドリームパレードプリンセスヘアアクセ',
            imgUrl      : '/images/items/PAF02-49.png',
            kind        : 'ヘアアクセ',
            color       : '銀',
            brand       : '',
            type        : 'PR',
            point       : 950,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DreamParadeCh',
            rare        : 'ER',
          }),


          item({
            collection  : 'DreamParadeCh',
            id          : 'PAF02-50',
            rare        : 'ER',
            name        : 'サマードリームパレードドレス',
            imgUrl      : '/images/items/PAF02-50.png',
            kind        : 'ワンピース',
            color       : '赤',
            brand       : '',
            type        : 'PR',
            point       : 2000,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DreamParadeCh',
            id          : 'PAF02-51',
            rare        : 'ER',
            name        : 'サマードリームパレードシューズ',
            imgUrl      : '/images/items/PAF02-51.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : '',
            type        : 'PR',
            point       : 950,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DreamParadeCh',
            id          : 'PAF02-52',
            rare        : 'ER',
            name        : 'サマードリームパレードヘアアクセ',
            imgUrl      : '/images/items/PAF02-52.png',
            kind        : 'ヘアアクセ',
            color       : '金',
            brand       : '',
            type        : 'PR',
            point       : 950,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DreamParadeCh',
            rare        : 'ER',
          }),


          item({
            collection  : 'DreamParadeCh',
            id          : 'PAF02-53',
            rare        : 'ER',
            name        : 'オータムドリームパレードドレス',
            imgUrl      : '/images/items/PAF02-53.png',
            kind        : 'ワンピース',
            color       : '青',
            brand       : '',
            type        : 'PR',
            point       : 2000,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DreamParadeCh',
            id          : 'PAF02-54',
            rare        : 'ER',
            name        : 'オータムドリームパレードシューズ',
            imgUrl      : '/images/items/PAF02-54.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : '',
            type        : 'PR',
            point       : 950,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DreamParadeCh',
            id          : 'PAF02-55',
            rare        : 'ER',
            name        : 'オータムドリームパレードヘアアクセ',
            imgUrl      : '/images/items/PAF02-55.png',
            kind        : 'ヘアアクセ',
            color       : '金',
            brand       : '',
            type        : 'PR',
            point       : 950,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DreamParadeCh',
            rare        : 'ER',
          }),


          item({
            collection  : 'DreamParadeCh',
            id          : 'PAF02-56',
            rare        : 'ER',
            name        : 'ウィンタードリームパレードドレス',
            imgUrl      : '/images/items/PAF02-56.png',
            kind        : 'ワンピース',
            color       : '水',
            brand       : '',
            type        : 'PR',
            point       : 2000,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DreamParadeCh',
            id          : 'PAF02-57',
            rare        : 'ER',
            name        : 'ウィンタードリームパレードシューズ',
            imgUrl      : '/images/items/PAF02-57.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : '',
            type        : 'PR',
            point       : 950,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DreamParadeCh',
            id          : 'PAF02-58',
            rare        : 'ER',
            name        : 'ウィンタードリームパレードヘアアクセ',
            imgUrl      : '/images/items/PAF02-58.png',
            kind        : 'ヘアアクセ',
            color       : '銀',
            brand       : '',
            type        : 'PR',
            point       : 950,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DreamParadeCh',
            rare        : 'ER',
          }),


          item({
            collection  : 'DreamParadeCh',
            id          : 'PAF02-59',
            rare        : 'ER',
            name        : 'スプリングドリームパレードドレス',
            imgUrl      : '/images/items/PAF02-59.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 2000,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DreamParadeCh',
            id          : 'PAF02-60',
            rare        : 'ER',
            name        : 'スプリングドリームパレードシューズ',
            imgUrl      : '/images/items/PAF02-60.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 950,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DreamParadeCh',
            id          : 'PAF02-61',
            rare        : 'ER',
            name        : 'スプリングドリームパレードヘアアクセ',
            imgUrl      : '/images/items/PAF02-61.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 950,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DreamParadeCh',
            rare        : 'ER',
          }),


          // [NOTE] ドリームパレードチャンネル PR
          // ================================================================================

          item({
            collection  : 'DreamParadeCh',
            id          : 'PAF02-62',
            rare        : 'PR',
            name        : 'スイートアンジュホワイティートップス',
            imgUrl      : '/images/items/PAF02-62.png',
            kind        : 'トップス',
            color       : '白',
            brand       : '',
            type        : 'LO',
            point       : 850,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'DreamParadeCh',
            id          : 'PAF02-63',
            rare        : 'PR',
            name        : 'スイートアンジュホワイティースカート',
            imgUrl      : '/images/items/PAF02-63.png',
            kind        : 'ボトムス',
            color       : '白',
            brand       : '',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DreamParadeCh',
            id          : 'PAF02-64',
            rare        : 'PR',
            name        : 'スイートアンジュホワイティーシューズ',
            imgUrl      : '/images/items/PAF02-64.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'LO',
            point       : 900,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DreamParadeCh',
            id          : 'PAF02-65',
            rare        : 'PR',
            name        : 'スイートアンジュヘアアクセ',
            imgUrl      : '/images/items/PAF02-65.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : '',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),


          item({
            collection  : 'DreamParadeCh',
            id          : 'PAF02-66',
            rare        : 'PR',
            name        : 'チーキーリトルサキュバストップス',
            imgUrl      : '/images/items/PAF02-66.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : '',
            type        : 'CO',
            point       : 850,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DreamParadeCh',
            id          : 'PAF02-67',
            rare        : 'PR',
            name        : 'チーキーリトルサキュバススカート',
            imgUrl      : '/images/items/PAF02-67.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : '',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DreamParadeCh',
            id          : 'PAF02-68',
            rare        : 'PR',
            name        : 'チーキーリトルサキュバスシューズ',
            imgUrl      : '/images/items/PAF02-68.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : '',
            type        : 'CO',
            point       : 900,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DreamParadeCh',
            id          : 'PAF02-69',
            rare        : 'PR',
            name        : 'チーキーリトルヘアアクセ',
            imgUrl      : '/images/items/PAF02-69.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : '',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'DreamParadeCh',
            id          : 'PAF02-70',
            rare        : 'PR',
            name        : 'パルプススカイカントリートップス',
            imgUrl      : '/images/items/PAF02-70.png',
            kind        : 'トップス',
            color       : '水',
            brand       : '',
            type        : 'NT',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DreamParadeCh',
            id          : 'PAF02-71',
            rare        : 'PR',
            name        : 'パルプススカイカントリースカート',
            imgUrl      : '/images/items/PAF02-71.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : '',
            type        : 'NT',
            point       : 900,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DreamParadeCh',
            id          : 'PAF02-72',
            rare        : 'PR',
            name        : 'パルプススカイカントリーシューズ',
            imgUrl      : '/images/items/PAF02-72.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : '',
            type        : 'NT',
            point       : 850,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DreamParadeCh',
            id          : 'PAF02-73',
            rare        : 'PR',
            name        : 'パルプススカイカントリーヘアアクセ',
            imgUrl      : '/images/items/PAF02-73.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : '',
            type        : 'NT',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'DreamParadeCh',
            id          : 'PAF02-74',
            rare        : 'PR',
            name        : 'ヴァンパイアローズトップス',
            imgUrl      : '/images/items/PAF02-74.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : '',
            type        : 'SE',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DreamParadeCh',
            id          : 'PAF02-75',
            rare        : 'PR',
            name        : 'ヴァンパイアローズパンツ',
            imgUrl      : '/images/items/PAF02-75.png',
            kind        : 'ボトムス',
            color       : '黒',
            brand       : '',
            type        : 'SE',
            point       : 900,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DreamParadeCh',
            id          : 'PAF02-76',
            rare        : 'PR',
            name        : 'ヴァンパイアローズシューズ',
            imgUrl      : '/images/items/PAF02-76.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : '',
            type        : 'SE',
            point       : 850,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DreamParadeCh',
            id          : 'PAF02-77',
            rare        : 'PR',
            name        : 'ヴァンパイアローズヘアアクセ',
            imgUrl      : '/images/items/PAF02-77.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : '',
            type        : 'SE',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),


          item({
            collection  : 'DreamParadeCh',
            id          : 'PAF02-78',
            rare        : 'PR',
            name        : 'プリパラポリスゴーゴートップス',
            imgUrl      : '/images/items/PAF02-78.png',
            kind        : 'トップス',
            color       : '青',
            brand       : '',
            type        : 'LO',
            point       : 850,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DreamParadeCh',
            id          : 'PAF02-79',
            rare        : 'PR',
            name        : 'プリパラポリスゴーゴーパンツ',
            imgUrl      : '/images/items/PAF02-79.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : '',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DreamParadeCh',
            id          : 'PAF02-80',
            rare        : 'PR',
            name        : 'プリパラポリスゴーゴーシューズ',
            imgUrl      : '/images/items/PAF02-80.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : '',
            type        : 'LO',
            point       : 900,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DreamParadeCh',
            id          : 'PAF02-81',
            rare        : 'PR',
            name        : 'プリパラポリスゴーゴーヘアアクセ',
            imgUrl      : '/images/items/PAF02-81.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : '',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] ドリームパレードチャンネル SR
          // ================================================================================

          item({
            collection  : 'DreamParadeCh',
            id          : 'PAF02-91',
            rare        : 'SR',
            name        : 'ココフラワーサイリウムワンピ',
            imgUrl      : '/images/items/PAF02-91.png',
            kind        : 'ワンピース',
            color       : '緑',
            brand       : '',
            type        : 'NT',
            point       : 1300,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'DreamParadeCh',
            id          : 'PAF02-92',
            rare        : 'SR',
            name        : 'ココフラワーサイリウムシューズ',
            imgUrl      : '/images/items/PAF02-92.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : '',
            type        : 'NT',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DreamParadeCh',
            id          : 'PAF02-93',
            rare        : 'SR',
            name        : 'ココフラワーサイリウムヘアアクセ',
            imgUrl      : '/images/items/PAF02-93.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : '',
            type        : 'NT',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DreamParadeCh',
            rare        : 'SR',
          }),


          item({
            collection  : 'DreamParadeCh',
            id          : 'PAF02-94',
            rare        : 'SR',
            name        : 'ブリリアントプリンスサイリウムワンピ',
            imgUrl      : '/images/items/PAF02-94.png',
            kind        : 'ワンピース',
            color       : '青',
            brand       : '',
            type        : 'SE',
            point       : 1300,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DreamParadeCh',
            id          : 'PAF02-95',
            rare        : 'SR',
            name        : 'ブリリアントプリンスサイリウムシューズ',
            imgUrl      : '/images/items/PAF02-95.png',
            kind        : 'シューズ',
            color       : '茶',
            brand       : '',
            type        : 'SE',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DreamParadeCh',
            id          : 'PAF02-96',
            rare        : 'SR',
            name        : 'ブリリアントプリンスサイリウムヘアアクセ',
            imgUrl      : '/images/items/PAF02-96.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : '',
            type        : 'SE',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DreamParadeCh',
            rare        : 'SR',
          }),


          item({
            collection  : 'DreamParadeCh',
            id          : 'PAF02-82',
            rare        : 'SR',
            name        : 'HTクラシックサイリウムワンピ',
            imgUrl      : '/images/items/PAF02-82.png',
            kind        : 'ワンピース',
            color       : '紫',
            brand       : '',
            type        : 'CO',
            point       : 1300,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DreamParadeCh',
            id          : 'PAF02-83',
            rare        : 'SR',
            name        : 'HTクラシックサイリウムシューズ',
            imgUrl      : '/images/items/PAF02-83.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : '',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DreamParadeCh',
            id          : 'PAF02-84',
            rare        : 'SR',
            name        : 'HTクラシックサイリウムヘアアクセ',
            imgUrl      : '/images/items/PAF02-84.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : '',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DreamParadeCh',
            rare        : 'SR',
          }),


          item({
            collection  : 'DreamParadeCh',
            id          : 'PAF02-85',
            rare        : 'SR',
            name        : 'シルキーハートサイリウムワンピ',
            imgUrl      : '/images/items/PAF02-85.png',
            kind        : 'ワンピース',
            color       : '水',
            brand       : '',
            type        : 'LO',
            point       : 1300,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'DreamParadeCh',
            id          : 'PAF02-86',
            rare        : 'SR',
            name        : 'シルキーハートサイリウムシューズ',
            imgUrl      : '/images/items/PAF02-86.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'DreamParadeCh',
            id          : 'PAF02-87',
            rare        : 'SR',
            name        : 'シルキーハートサイリウムヘアアクセ',
            imgUrl      : '/images/items/PAF02-87.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'DreamParadeCh',
            rare        : 'SR',
          }),


          item({
            collection  : 'DreamParadeCh',
            id          : 'PAF02-88',
            rare        : 'SR',
            name        : 'マリオネットミューレッドサイリウムワンピ',
            imgUrl      : '/images/items/PAF02-88.png',
            kind        : 'ワンピース',
            color       : '赤',
            brand       : '',
            type        : 'LO',
            point       : 1300,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DreamParadeCh',
            id          : 'PAF02-89',
            rare        : 'SR',
            name        : 'マリオネットミューレッドサイリウムシューズ',
            imgUrl      : '/images/items/PAF02-89.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DreamParadeCh',
            id          : 'PAF02-90',
            rare        : 'SR',
            name        : 'マリオネットミューレッドサイリウムヘアアクセ',
            imgUrl      : '/images/items/PAF02-90.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DreamParadeCh',
            rare        : 'SR',
          }),


          item({
            collection  : 'DreamParadeCh',
            id          : 'PAF02-97',
            rare        : 'SR',
            name        : 'CAモアサイリウムワンピ',
            imgUrl      : '/images/items/PAF02-97.png',
            kind        : 'ワンピース',
            color       : '青',
            brand       : '',
            type        : 'PO',
            point       : 1300,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DreamParadeCh',
            id          : 'PAF02-98',
            rare        : 'SR',
            name        : 'CAモアサイリウムシューズ',
            imgUrl      : '/images/items/PAF02-98.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : '',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DreamParadeCh',
            id          : 'PAF02-99',
            rare        : 'SR',
            name        : 'CAモアサイリウムヘアアクセ',
            imgUrl      : '/images/items/PAF02-99.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : '',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DreamParadeCh',
            rare        : 'SR',
          }),


          item({
            collection  : 'DreamParadeCh',
            id          : 'PAF02-100',
            rare        : 'SR',
            name        : 'あおぞらマーチトップス',
            imgUrl      : '/images/items/PAF02-100.png',
            kind        : 'トップス',
            color       : '水',
            brand       : '',
            type        : 'PO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'DreamParadeCh',
            id          : 'PAF02-101',
            rare        : 'SR',
            name        : 'あおぞらマーチスカート',
            imgUrl      : '/images/items/PAF02-101.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : '',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'DreamParadeCh',
            id          : 'PAF02-102',
            rare        : 'SR',
            name        : 'あおぞらマーチシューズ',
            imgUrl      : '/images/items/PAF02-102.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : '',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'DreamParadeCh',
            id          : 'PAF02-103',
            rare        : 'SR',
            name        : 'あおぞらマーチヘアアクセ',
            imgUrl      : '/images/items/PAF02-103.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : '',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),


          // [NOTE] イルミナージュコーデ
          // ================================================================================

          externalItem(itemsPriTama01, 'IR01-01', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama01, 'IR01-02', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama01, 'IR01-03', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama01, 'IR01-04', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama01, 'IR01-05', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama01, 'IR01-06', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),



          externalItem(itemsPriTama01, 'IR01-07', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama01, 'IR01-08', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama01, 'IR01-09', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama02, 'IR02-01', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama02, 'IR02-02', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama02, 'IR02-03', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama02, 'IR02-04', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama02, 'IR02-05', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama02, 'IR02-06', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama02, 'IR02-07', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama02, 'IR02-08', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama02, 'IR02-09', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama03, 'IR03-01', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama03, 'IR03-02', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama03, 'IR03-03', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama03, 'IR03-04', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama03, 'IR03-05', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama03, 'IR03-06', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama03, 'IR03-07', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama03, 'IR03-08', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama03, 'IR03-09', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama04, 'IR04-01', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama04, 'IR04-02', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama04, 'IR04-03', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama04, 'IR04-04', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama04, 'IR04-05', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama04, 'IR04-06', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama04, 'IR04-07', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama04, 'IR04-08', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama04, 'IR04-09', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama04, 'IR04-10', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama04, 'IR04-11', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama04, 'IR04-12', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama04, 'IR04-13', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama04, 'IR04-14', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama04, 'IR04-15', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama04, 'IR04-16', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama04, 'IR04-17', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama04, 'IR04-18', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama05, 'IR05-01', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama05, 'IR05-02', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama05, 'IR05-03', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama05, 'IR05-04', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama05, 'IR05-05', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama05, 'IR05-06', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama05, 'IR05-07', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama05, 'IR05-08', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama05, 'IR05-09', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          // [NOTE] ジュエルアイドルチャンネル JR
          // ================================================================================

          externalItem(itemsJewel01, 'JR1-01', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel01, 'JR1-02', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel01, 'JR1-03', { collection: 'JewelIdolCh' }),
          item({ rare: 'JR', collection: 'JewelIdolCh' }),


          externalItem(itemsJewel02, 'JR2-01', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel02, 'JR2-02', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel02, 'JR2-03', { collection: 'JewelIdolCh' }),
          item({ rare: 'JR', collection: 'JewelIdolCh' }),


          externalItem(itemsJewel02, 'JR3-01', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel02, 'JR3-02', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel02, 'JR3-03', { collection: 'JewelIdolCh' }),
          item({ rare: 'JR', collection: 'JewelIdolCh' }),


          externalItem(itemsJewel03, 'JR4-01', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel03, 'JR4-02', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel03, 'JR4-03', { collection: 'JewelIdolCh' }),
          item({ rare: 'JR', collection: 'JewelIdolCh' }),


          externalItem(itemsJewel03, 'JR5-01', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel03, 'JR5-02', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel03, 'JR5-03', { collection: 'JewelIdolCh' }),
          item({ rare: 'JR', collection: 'JewelIdolCh' }),


          externalItem(itemsJewel04, 'JR6-01', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel04, 'JR6-02', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel04, 'JR6-03', { collection: 'JewelIdolCh' }),
          item({ rare: 'JR', collection: 'JewelIdolCh' }),


          externalItem(itemsJewel04, 'JR7-01', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel04, 'JR7-02', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel04, 'JR7-03', { collection: 'JewelIdolCh' }),
          item({ rare: 'JR', collection: 'JewelIdolCh' }),


          externalItem(itemsJewel05, 'JR8-01', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel05, 'JR8-02', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel05, 'JR8-03', { collection: 'JewelIdolCh' }),
          item({ rare: 'JR', collection: 'JewelIdolCh' }),


          externalItem(itemsJewel05, 'JR9-01', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel05, 'JR9-02', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel05, 'JR9-03', { collection: 'JewelIdolCh' }),
          item({ rare: 'JR', collection: 'JewelIdolCh' }),


          externalItem(itemsJewel06, 'JR10-01', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel06, 'JR10-02', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel06, 'JR10-03', { collection: 'JewelIdolCh' }),
          item({ rare: 'JR', collection: 'JewelIdolCh' }),


          externalItem(itemsJewel06, 'JR11-01', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel06, 'JR11-02', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel06, 'JR11-03', { collection: 'JewelIdolCh' }),
          item({ rare: 'JR', collection: 'JewelIdolCh' }),


          // [NOTE] ジュエルアイドルチャンネル PR
          // ================================================================================

          externalItem(itemsJewel01, 'J1-08', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel01, 'J1-09', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel01, 'J1-10', { collection: 'JewelIdolCh' }),
          item({ rare: 'PR', collection: 'JewelIdolCh' }),


          externalItem(itemsJewel01, 'J1-68', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel01, 'J1-69', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel01, 'J1-70', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel01, 'J1-71', { collection: 'JewelIdolCh' }),


          externalItem(itemsJewel02, 'J2-68', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel02, 'J2-69', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel02, 'J2-70', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel02, 'J2-71', { collection: 'JewelIdolCh' }),


          externalItem(itemsJewel03, 'J3-07', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel03, 'J3-08', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel03, 'J3-09', { collection: 'JewelIdolCh' }),
          item({ rare: 'PR', collection: 'JewelIdolCh' }),

          externalItem(itemsJewel03, 'J3-10', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel03, 'J3-11', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel03, 'J3-12', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel03, 'J3-13', { collection: 'JewelIdolCh' }),


          externalItem(itemsJewel04, 'J4-102', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel04, 'J4-103', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel04, 'J4-104', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel04, 'J4-105', { collection: 'JewelIdolCh' }),


          externalItem(itemsJewel05, 'J5-97', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel05, 'J5-98', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel05, 'J5-99', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel05, 'J5-100', { collection: 'JewelIdolCh' }),


          externalItem(itemsJewel05, 'J5-101', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel05, 'J5-102', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel05, 'J5-103', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel05, 'J5-104', { collection: 'JewelIdolCh' }),


          externalItem(itemsJewel05, 'J5-93', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel05, 'J5-94', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel05, 'J5-95', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel05, 'J5-96', { collection: 'JewelIdolCh' }),


          externalItem(itemsJewel06, 'J6-11', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel06, 'J6-12', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel06, 'J6-13', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel06, 'J6-14', { collection: 'JewelIdolCh' }),


          externalItem(itemsPromo2019_Events, 'DF-03', { collection: 'JewelIdolCh' }),
          externalItem(itemsPromo2019_Events, 'DF-01', { collection: 'JewelIdolCh' }),
          externalItem(itemsPromo2019_Events, 'DF-02', { collection: 'JewelIdolCh' }),
          item({ rare: 'PR', collection: 'JewelIdolCh' }),


          // [NOTE] ジュエルアイドルチャンネル SR
          // ================================================================================



          // [NOTE] プリティーオールフレンズチャンネル
          // ================================================================================

          externalItem(itemsPAF01, 'PAF01-87', { collection: 'PAFCh' }),
          externalItem(itemsPAF01, 'PAF01-88', { collection: 'PAFCh' }),
          externalItem(itemsPAF01, 'PAF01-89', { collection: 'PAFCh' }),
          externalItem(itemsPAF01, 'PAF01-90', { collection: 'PAFCh' }),


          externalItem(itemsPAF01, 'PAF01-91', { collection: 'PAFCh' }),
          externalItem(itemsPAF01, 'PAF01-92', { collection: 'PAFCh' }),
          externalItem(itemsPAF01, 'PAF01-93', { collection: 'PAFCh' }),
          externalItem(itemsPAF01, 'PAF01-94', { collection: 'PAFCh' }),


          externalItem(itemsPAF01, 'PAF01-95', { collection: 'PAFCh' }),
          externalItem(itemsPAF01, 'PAF01-96', { collection: 'PAFCh' }),
          externalItem(itemsPAF01, 'PAF01-97', { collection: 'PAFCh' }),
          externalItem(itemsPAF01, 'PAF01-98', { collection: 'PAFCh' }),


          externalItem(itemsPAF01, 'PAF01-107', { collection: 'PAFCh' }),
          externalItem(itemsPAF01, 'PAF01-108', { collection: 'PAFCh' }),
          externalItem(itemsPAF01, 'PAF01-109', { collection: 'PAFCh' }),
          externalItem(itemsPAF01, 'PAF01-110', { collection: 'PAFCh' }),


          externalItem(itemsPAF01, 'PAF01-111', { collection: 'PAFCh' }),
          externalItem(itemsPAF01, 'PAF01-112', { collection: 'PAFCh' }),
          externalItem(itemsPAF01, 'PAF01-113', { collection: 'PAFCh' }),
          externalItem(itemsPAF01, 'PAF01-114', { collection: 'PAFCh' }),


          externalItem(itemsPAF01, 'PAF01-103', { collection: 'PAFCh' }),
          externalItem(itemsPAF01, 'PAF01-104', { collection: 'PAFCh' }),
          externalItem(itemsPAF01, 'PAF01-105', { collection: 'PAFCh' }),
          externalItem(itemsPAF01, 'PAF01-106', { collection: 'PAFCh' }),


          externalItem(itemsPAF01, 'PAF01-99', { collection: 'PAFCh' }),
          externalItem(itemsPAF01, 'PAF01-100', { collection: 'PAFCh' }),
          externalItem(itemsPAF01, 'PAF01-101', { collection: 'PAFCh' }),
          externalItem(itemsPAF01, 'PAF01-102', { collection: 'PAFCh' }),


          externalItem(itemsJewel04  , 'PAF-J4-01', { collection: 'PAFCh' }),
          externalItem(itemsJewel04  , 'PAF-J4-02', { collection: 'PAFCh' }),
          externalItem(itemsJewel04  , 'PAF-J4-03', { collection: 'PAFCh' }),
          externalItem(itemsJewel04  , 'PAF-J4-04', { collection: 'PAFCh' }),


          externalItem(itemsJewel04  , 'PAF-J4-05', { collection: 'PAFCh' }),
          externalItem(itemsJewel04  , 'PAF-J4-06', { collection: 'PAFCh' }),
          externalItem(itemsJewel04  , 'PAF-J4-07', { collection: 'PAFCh' }),
          item({ collection: 'PAFCh', rare: 'SR' }),


          externalItem(itemsJewel04  , 'PAF-J4-08', { collection: 'PAFCh' }),
          externalItem(itemsJewel04  , 'PAF-J4-09', { collection: 'PAFCh' }),
          externalItem(itemsJewel04  , 'PAF-J4-10', { collection: 'PAFCh' }),
          item({ collection: 'PAFCh', rare: 'SR' }),


          externalItem(itemsJewel05  , 'PAF-J5-01', { collection: 'PAFCh' }),
          externalItem(itemsJewel05  , 'PAF-J5-02', { collection: 'PAFCh' }),
          externalItem(itemsJewel05  , 'PAF-J5-03', { collection: 'PAFCh' }),
          externalItem(itemsJewel05  , 'PAF-J5-04', { collection: 'PAFCh' }),


          externalItem(itemsJewel05  , 'PAF-J5-05', { collection: 'PAFCh' }),
          externalItem(itemsJewel05  , 'PAF-J5-06', { collection: 'PAFCh' }),
          externalItem(itemsJewel05  , 'PAF-J5-07', { collection: 'PAFCh' }),
          externalItem(itemsJewel05  , 'PAF-J5-08', { collection: 'PAFCh' }),


          externalItem(itemsJewel05  , 'PAF-J5-09', { collection: 'PAFCh' }),
          externalItem(itemsJewel05  , 'PAF-J5-10', { collection: 'PAFCh' }),
          item({ collection: 'PAFCh', rare: 'SR' }),
          item({ collection: 'PAFCh', rare: 'SR' }),


          externalItem(itemsPriTama01, 'PT1-113', { collection: 'PAFCh' }),
          externalItem(itemsPriTama01, 'PT1-114', { collection: 'PAFCh' }),
          externalItem(itemsPriTama01, 'PT1-115', { collection: 'PAFCh' }),
          item({ collection: 'PAFCh', rare: 'SR' }),


          externalItem(itemsPriTama01, 'PT1-116', { collection: 'PAFCh' }),
          externalItem(itemsPriTama01, 'PT1-117', { collection: 'PAFCh' }),
          externalItem(itemsPriTama01, 'PT1-118', { collection: 'PAFCh' }),
          item({ collection: 'PAFCh', rare: 'SR' }),


          externalItem(itemsPriTama01, 'PT1-119', { collection: 'PAFCh' }),
          externalItem(itemsPriTama01, 'PT1-120', { collection: 'PAFCh' }),
          externalItem(itemsPriTama01, 'PT1-121', { collection: 'PAFCh' }),
          item({ collection: 'PAFCh', rare: 'SR' }),


          externalItem(itemsPriTama02, 'PT2-118', { collection: 'PAFCh' }),
          externalItem(itemsPriTama02, 'PT2-119', { collection: 'PAFCh' }),
          externalItem(itemsPriTama02, 'PT2-120', { collection: 'PAFCh' }),
          item({ collection: 'PAFCh', rare: 'SR' }),


          externalItem(itemsPriTama02, 'PT2-121', { collection: 'PAFCh' }),
          externalItem(itemsPriTama02, 'PT2-122', { collection: 'PAFCh' }),
          externalItem(itemsPriTama02, 'PT2-123', { collection: 'PAFCh' }),
          item({ collection: 'PAFCh', rare: 'SR' }),


          externalItem(itemsPriTama02, 'PT2-124', { collection: 'PAFCh' }),
          externalItem(itemsPriTama02, 'PT2-125', { collection: 'PAFCh' }),
          externalItem(itemsPriTama02, 'PT2-126', { collection: 'PAFCh' }),
          item({ collection: 'PAFCh', rare: 'SR' }),


          // [NOTE] パシャッとアイテムチャンネル
          // ================================================================================

          externalItem(itemsPriTama05, 'PT5-122' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol01    , 'PCH1-66' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol01    , 'PCH1-67' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol01    , 'PCH1-68' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol02    , 'PCH2-68' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol02    , 'PCH2-69' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol03    , 'PCH3-68' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol03    , 'PCH3-70' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol04    , 'PCH4-15' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol04    , 'PCH4-61' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol04    , 'PCH4-81' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol05    , 'PCH5-20' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol05    , 'PCH5-86' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol05    , 'SL5-98'  , { collection: 'PashaItemCh' }),
          externalItem(itemsVol05    , 'SL5-99'  , { collection: 'PashaItemCh' }),
          externalItem(itemsVol06    , 'PCH6-24' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol06    , 'PCH6-110', { collection: 'PashaItemCh' }),
          externalItem(itemsJewel01  , 'J1-19'   , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel01  , 'J1-79'   , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel02  , 'J2-23'   , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel02  , 'J2-83'   , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel03  , 'J3-30'   , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel03  , 'J3-102'  , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel05  , 'J5-37'   , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel06  , 'J6-42'   , { collection: 'PashaItemCh' }),
          externalItem(itemsPriTama01, 'PT1-46'  , { collection: 'PashaItemCh' }),
          externalItem(itemsPriTama02, 'PT2-44'  , { collection: 'PashaItemCh' }),
          externalItem(itemsPriTama02, 'PB-83'   , { collection: 'PashaItemCh' }),
          externalItem(itemsPriTama03, 'PT3-43'  , { collection: 'PashaItemCh' }),
          externalItem(itemsPriTama03, 'PB-91-P' , { collection: 'PashaItemCh' }),
          externalItem(itemsPriTama04, 'PB-98'   , { collection: 'PashaItemCh' }),
          externalItem(itemsPriTama05, 'PB-123'  , { collection: 'PashaItemCh' }),
          externalItem(itemsPriTama05, 'PT5-117' , { collection: 'PashaItemCh' }),
          externalItem(itemsPriTama05, 'PT5-118' , { collection: 'PashaItemCh' }),
          externalItem(itemsPriTama05, 'PT5-119' , { collection: 'PashaItemCh' }),
          externalItem(itemsPriTama05, 'PT5-120' , { collection: 'PashaItemCh' }),
          externalItem(itemsPriTama05, 'PT5-121' , { collection: 'PashaItemCh' }),
          externalItem(itemsPriTama05, 'PT5-44'  , { collection: 'PashaItemCh' }),
          externalItem(itemsPriTama06, 'PB-157'  , { collection: 'PashaItemCh' }),
          externalItem(itemsVol01    , 'PCH1-69' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol01    , 'PCH1-70' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol02    , 'PCH2-70' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol02    , 'PCH2-71' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol02    , 'PCH2-72' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol03    , 'PCH3-71' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol03    , 'PCH3-72' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol03    , 'PCH3-73' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol04    , 'PCH4-51' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol04    , 'PCH4-52' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol05    , 'PCH5-52' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol05    , 'PCH5-53' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol05    , 'PCH5-54' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol06    , 'PCH6-63' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol06    , 'PCH6-64' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol06    , 'PCH6-65' , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel01  , 'J1-30'   , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel01  , 'J1-87'   , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel02  , 'J2-38'   , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel02  , 'J2-39'   , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel03  , 'J3-52'   , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel03  , 'J3-53'   , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel04  , 'J4-37'   , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel04  , 'J4-38'   , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel04  , 'J4-118'  , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel04  , 'J4-119'  , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel04  , 'PB-24'   , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel05  , 'J5-56'   , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel05  , 'J5-57'   , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel05  , 'PB-42'   , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel06  , 'PB-61'   , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel06  , 'PB-62'   , { collection: 'PashaItemCh' }),
          externalItem(itemsPriTama01, 'PT1-51'  , { collection: 'PashaItemCh' }),
          externalItem(itemsPriTama01, 'PT1-52'  , { collection: 'PashaItemCh' }),
          externalItem(itemsPriTama01, 'PB-71'   , { collection: 'PashaItemCh' }),


          // [NOTE] ニコチケ PR プリティーコレクションその2
          // ================================================================================

          item({
            collection  : 'PrettyCollection2',
            id          : 'NC-F2-01',
            rare        : 'PR',
            name        : 'DCピュリティベアワンピ',
            imgUrl      : '/images/items/NC-F2-01.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 1600,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PrettyCollection2',
            id          : 'NC-F2-02',
            rare        : 'PR',
            name        : 'DCピュリティブーツ',
            imgUrl      : '/images/items/NC-F2-02.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : '',
            type        : 'PR',
            point       : 850,
            aggregation : 'NC-F2-01',
          }),
          item({
            collection  : 'PrettyCollection2',
            rare        : 'PR',
          }),
          item({
            collection  : 'PrettyCollection2',
            rare        : 'PR',
          }),


          item({
            collection  : 'PrettyCollection2',
            id          : 'NC-F2-03',
            rare        : 'PR',
            name        : 'DCピュリティスタージャケット',
            imgUrl      : '/images/items/NC-F2-03.png',
            kind        : 'トップス',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 900,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PrettyCollection2',
            id          : 'NC-F2-04',
            rare        : 'PR',
            name        : 'DCピュリティフリルスカート',
            imgUrl      : '/images/items/NC-F2-04.png',
            kind        : 'ボトムス',
            color       : '黒',
            brand       : '',
            type        : 'PR',
            point       : 800,
            aggregation : 'NC-F2-03',
          }),
          item({
            collection  : 'PrettyCollection2',
            id          : 'NC-F2-05',
            rare        : 'PR',
            name        : 'DCピュリティブーツ',
            imgUrl      : '/images/items/NC-F2-05.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : '',
            type        : 'PR',
            point       : 850,
            aggregation : 'NC-F2-03',
          }),
          item({
            collection  : 'PrettyCollection2',
            rare        : 'PR',
          }),


          item({
            collection  : 'PrettyCollection2',
            id          : 'NC-F2-06',
            rare        : 'PR',
            name        : 'プリズミー☆サンシャインベスト',
            imgUrl      : '/images/items/NC-F2-06.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : '',
            type        : 'PR',
            point       : 800,
            numOwned    : { nico: 0 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PrettyCollection2',
            id          : 'NC-F2-07',
            rare        : 'PR',
            name        : 'プリズミー☆サンシャインスカート',
            imgUrl      : '/images/items/NC-F2-07.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : '',
            type        : 'PR',
            point       : 900,
            aggregation : 'NC-F2-06',
          }),
          item({
            collection  : 'PrettyCollection2',
            id          : 'NC-F2-08',
            rare        : 'PR',
            name        : 'ラインリボンロングブーツ',
            imgUrl      : '/images/items/PAF01-13.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : '',
            type        : 'PR',
            point       : 850,
            aggregation : 'NC-F2-06',
          }),
          item({
            collection  : 'PrettyCollection2',
            rare        : 'PR',
          }),


          item({
            collection  : 'PrettyCollection2',
            id          : 'NC-F2-09',
            rare        : 'PR',
            name        : 'プリズミー☆ナイトスターベスト',
            imgUrl      : '/images/items/NC-F2-09.png',
            kind        : 'トップス',
            color       : '黒',
            brand       : '',
            type        : 'PR',
            point       : 800,
            numOwned    : { nico: 0 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PrettyCollection2',
            id          : 'NC-F2-10',
            rare        : 'PR',
            name        : 'プリズミー☆ナイトスターパンツ',
            imgUrl      : '/images/items/NC-F2-10.png',
            kind        : 'ボトムス',
            color       : '黒',
            brand       : '',
            type        : 'PR',
            point       : 900,
            aggregation : 'NC-F2-09',
          }),
          item({
            collection  : 'PrettyCollection2',
            id          : 'NC-F2-11',
            rare        : 'PR',
            name        : 'ラインリボンロングブーツ',
            imgUrl      : '/images/items/PAF01-13.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : '',
            type        : 'PR',
            point       : 850,
            aggregation : 'NC-F2-09',
          }),
          item({
            collection  : 'PrettyCollection2',
            rare        : 'PR',
          }),


          item({
            collection  : 'PrettyCollection2',
            id          : 'NC-F2-12',
            rare        : 'PR',
            name        : 'トンでもサマー☆アドベンチャートップス',
            imgUrl      : '/images/items/NC-F2-12.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : '',
            type        : 'NT',
            point       : 800,
            numOwned    : { nico: 0 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PrettyCollection2',
            id          : 'NC-F2-13',
            rare        : 'PR',
            name        : 'トンでもサマー☆アドベンチャースカート',
            imgUrl      : '/images/items/NC-F2-13.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : '',
            type        : 'NT',
            point       : 850,
            aggregation : 'NC-F2-12',
          }),
          item({
            collection  : 'PrettyCollection2',
            id          : 'NC-F2-14',
            rare        : 'PR',
            name        : 'トンでもサマー☆アドベンチャーシューズ',
            imgUrl      : '/images/items/NC-F2-14.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : '',
            type        : 'NT',
            point       : 900,
            aggregation : 'NC-F2-12',
          }),
          item({
            collection  : 'PrettyCollection2',
            id          : 'NC-F2-15',
            rare        : 'PR',
            name        : 'トンでもサマー☆アドベンチャーヘアアクセ',
            imgUrl      : '/images/items/NC-F2-15.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : '',
            type        : 'NT',
            point       : 800,
            aggregation : 'NC-F2-12',
          }),


          item({
            collection  : 'PrettyCollection2',
            id          : 'NC-F2-16',
            rare        : 'PR',
            name        : 'デリシャスシェフトップス',
            imgUrl      : '/images/items/NC-F2-16.png',
            kind        : 'トップス',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 800,
            numOwned    : { nico: 0 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PrettyCollection2',
            id          : 'NC-F2-17',
            rare        : 'PR',
            name        : 'デリシャスシェフスカート',
            imgUrl      : '/images/items/NC-F2-17.png',
            kind        : 'ボトムス',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 850,
            aggregation : 'NC-F2-16',
          }),
          item({
            collection  : 'PrettyCollection2',
            id          : 'NC-F2-18',
            rare        : 'PR',
            name        : 'デリシャスシェフシューズ',
            imgUrl      : '/images/items/NC-F2-18.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 900,
            aggregation : 'NC-F2-16',
          }),
          item({
            collection  : 'PrettyCollection2',
            id          : 'NC-F2-19',
            rare        : 'PR',
            name        : 'シェフハットヘアアクセ',
            imgUrl      : '/images/items/NC-F2-19.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 800,
            aggregation : 'NC-F2-16',
          }),


          item({
            collection  : 'PrettyCollection2',
            id          : 'NC-F2-20',
            rare        : 'PR',
            name        : 'エスコートシネマワンピ',
            imgUrl      : '/images/items/NC-F2-20.png',
            kind        : 'ワンピース',
            color       : '黒',
            brand       : '',
            type        : 'SE',
            point       : 1600,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PrettyCollection2',
            id          : 'NC-F2-21',
            rare        : 'PR',
            name        : 'エスコートシネマシューズ',
            imgUrl      : '/images/items/NC-F2-21.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : '',
            type        : 'SE',
            point       : 800,
            aggregation : 'NC-F2-20',
          }),
          item({
            collection  : 'PrettyCollection2',
            id          : 'NC-F2-22',
            rare        : 'PR',
            name        : 'エスコートシネマヘアアクセ',
            imgUrl      : '/images/items/NC-F2-22.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : '',
            type        : 'SE',
            point       : 800,
            aggregation : 'NC-F2-20',
          }),
          item({
            collection  : 'PrettyCollection2',
            rare        : 'PR',
          }),


          item({
            collection  : 'PrettyCollection2',
            id          : 'NC-F2-23',
            rare        : 'PR',
            name        : 'かれいなるジェットレッドトップス',
            imgUrl      : '/images/items/SLJ5-30.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : '',
            type        : 'SE',
            point       : 800,
            numOwned    : { nico: 0 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PrettyCollection2',
            id          : 'NC-F2-24',
            rare        : 'PR',
            name        : 'かれいなるジェットレッドパンツ',
            imgUrl      : '/images/items/SLJ5-31.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : '',
            type        : 'SE',
            point       : 850,
            aggregation : 'NC-F2-23',
          }),
          item({
            collection  : 'PrettyCollection2',
            id          : 'NC-F2-25',
            rare        : 'PR',
            name        : 'かれいなるジェットレッドシューズ',
            imgUrl      : '/images/items/SLJ5-32.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : '',
            type        : 'SE',
            point       : 900,
            aggregation : 'NC-F2-23',
          }),
          item({
            collection  : 'PrettyCollection2',
            id          : 'NC-F2-26',
            rare        : 'PR',
            name        : 'かれいなるジェットレッドヘアアクセ',
            imgUrl      : '/images/items/SLJ5-33.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : '',
            type        : 'SE',
            point       : 800,
            aggregation : 'NC-F2-23',
          }),


          item({
            collection  : 'PrettyCollection2',
            id          : 'NC-F2-27',
            rare        : 'PR',
            name        : 'ヒッチハイクドライブトップス',
            imgUrl      : '/images/items/NC-F2-27.png',
            kind        : 'トップス',
            color       : '白',
            brand       : '',
            type        : 'LO',
            point       : 800,
            numOwned    : { nico: 0 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PrettyCollection2',
            id          : 'NC-F2-28',
            rare        : 'PR',
            name        : 'ヒッチハイクドライブスカート',
            imgUrl      : '/images/items/NC-F2-28.png',
            kind        : 'ボトムス',
            color       : '白',
            brand       : '',
            type        : 'LO',
            point       : 900,
            aggregation : 'NC-F2-27',
          }),
          item({
            collection  : 'PrettyCollection2',
            id          : 'NC-F2-29',
            rare        : 'PR',
            name        : 'ヒッチハイクドライブシューズ',
            imgUrl      : '/images/items/NC-F2-29.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'LO',
            point       : 850,
            aggregation : 'NC-F2-27',
          }),
          item({
            collection  : 'PrettyCollection2',
            id          : 'NC-F2-30',
            rare        : 'PR',
            name        : 'ヒッチハイクドライブヘアアクセ',
            imgUrl      : '/images/items/NC-F2-30.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : '',
            type        : 'LO',
            point       : 800,
            aggregation : 'NC-F2-27',
          }),


          item({
            collection  : 'PrettyCollection2',
            id          : 'NC-F2-31',
            rare        : 'PR',
            name        : 'トリッキーキャンディトップス',
            imgUrl      : '/images/items/J6-97.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'MR',
            type        : 'PO',
            point       : 850,
            numOwned    : { nico: 0 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PrettyCollection2',
            id          : 'NC-F2-32',
            rare        : 'PR',
            name        : 'トリッキーキャンディスカート',
            imgUrl      : '/images/items/J6-98.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'MR',
            type        : 'PO',
            point       : 900,
            aggregation : 'NC-F2-31',
          }),
          item({
            collection  : 'PrettyCollection2',
            id          : 'NC-F2-33',
            rare        : 'PR',
            name        : 'トリッキーキャンディシューズ',
            imgUrl      : '/images/items/J6-99.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'MR',
            type        : 'PO',
            point       : 800,
            aggregation : 'NC-F2-31',
          }),
          item({
            collection  : 'PrettyCollection2',
            id          : 'NC-F2-34',
            rare        : 'PR',
            name        : 'トリッキーキャンディヘアアクセ',
            imgUrl      : '/images/items/J6-100.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'MR',
            type        : 'PO',
            point       : 800,
            aggregation : 'NC-F2-31',
          }),


          item({
            collection  : 'PrettyCollection2',
            id          : 'NC-J3P-79',
            rare        : 'PR',
            name        : 'ジャンピンラビッツキューティートップス',
            imgUrl      : '/images/items/J3-79.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'CH',
            type        : 'LO',
            point       : 900,
            numOwned    : { nico: 0 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PrettyCollection2',
            id          : 'NC-J3P-80',
            rare        : 'PR',
            name        : 'ジャンピンラビッツキューティースカート',
            imgUrl      : '/images/items/J3-80.png',
            kind        : 'ボトムス',
            color       : '白',
            brand       : 'CH',
            type        : 'LO',
            point       : 850,
            aggregation : 'NC-J3P-79',
          }),
          item({
            collection  : 'PrettyCollection2',
            id          : 'NC-J3P-81',
            rare        : 'PR',
            name        : 'ジャンピンラビッツキューティーシューズ',
            imgUrl      : '/images/items/J3-81.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'CH',
            type        : 'LO',
            point       : 800,
            aggregation : 'NC-J3P-79',
          }),
          item({
            collection  : 'PrettyCollection2',
            id          : 'NC-J3P-82',
            rare        : 'PR',
            name        : 'ジャンピンラビッツキューティーヘアアクセ',
            imgUrl      : '/images/items/J3-82.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'CH',
            type        : 'LO',
            point       : 800,
            aggregation : 'NC-J3P-79',
          }),


          item({
            collection  : 'PrettyCollection2',
            id          : 'NC-J3P-83',
            rare        : 'PR',
            name        : 'ジャンピンラビッツクールトップス',
            imgUrl      : '/images/items/J3-83.png',
            kind        : 'トップス',
            color       : '黒',
            brand       : 'DS',
            type        : 'CO',
            point       : 800,
            numOwned    : { nico: 0 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PrettyCollection2',
            id          : 'NC-J3P-84',
            rare        : 'PR',
            name        : 'ジャンピンラビッツクールパンツ',
            imgUrl      : '/images/items/J3-84.png',
            kind        : 'ボトムス',
            color       : '黒',
            brand       : 'DS',
            type        : 'CO',
            point       : 900,
            aggregation : 'NC-J3P-83',
          }),
          item({
            collection  : 'PrettyCollection2',
            id          : 'NC-J3P-85',
            rare        : 'PR',
            name        : 'ジャンピンラビッツクールシューズ',
            imgUrl      : '/images/items/J3-85.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'DS',
            type        : 'CO',
            point       : 850,
            aggregation : 'NC-J3P-83',
          }),
          item({
            collection  : 'PrettyCollection2',
            id          : 'NC-J3P-86',
            rare        : 'PR',
            name        : 'ジャンピンラビッツクールヘアアクセ',
            imgUrl      : '/images/items/J3-86.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'DS',
            type        : 'CO',
            point       : 800,
            aggregation : 'NC-J3P-83',
          }),


          item({
            collection  : 'PrettyCollection2',
            id          : 'NC-J4P-17',
            rare        : 'PR',
            name        : 'フルスイングスタートップス',
            imgUrl      : '/images/items/J4-17.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'GY',
            type        : 'PO',
            point       : 800,
            numOwned    : { nico: 0 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PrettyCollection2',
            id          : 'NC-J4P-18',
            rare        : 'PR',
            name        : 'フルスイングスターパンツ',
            imgUrl      : '/images/items/J4-18.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'GY',
            type        : 'PO',
            point       : 900,
            aggregation : 'NC-J4P-17',
          }),
          item({
            collection  : 'PrettyCollection2',
            id          : 'NC-J4P-19',
            rare        : 'PR',
            name        : 'フルスイングスターシューズ',
            imgUrl      : '/images/items/J4-19.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'GY',
            type        : 'PO',
            point       : 850,
            aggregation : 'NC-J4P-17',
          }),
          item({
            collection  : 'PrettyCollection2',
            id          : 'NC-J4P-20',
            rare        : 'PR',
            name        : 'フルスイングスターヘアアクセ',
            imgUrl      : '/images/items/J4-20.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'GY',
            type        : 'PO',
            point       : 800,
            aggregation : 'NC-J4P-17',
          }),


          item({
            collection  : 'PrettyCollection2',
            id          : 'NC-J5P-23',
            rare        : 'PR',
            name        : 'ミス・ドラマティックブルートップス',
            imgUrl      : '/images/items/J5-23.png',
            kind        : 'トップス',
            color       : '水',
            brand       : 'DW',
            type        : 'LO',
            point       : 850,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PrettyCollection2',
            id          : 'NC-J5P-24',
            rare        : 'PR',
            name        : 'ミス・ドラマティックブルースカート',
            imgUrl      : '/images/items/J5-24.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'DW',
            type        : 'LO',
            point       : 800,
            aggregation : 'NC-J5P-23',
          }),
          item({
            collection  : 'PrettyCollection2',
            id          : 'NC-J5P-25',
            rare        : 'PR',
            name        : 'ミス・ドラマティックブルーシューズ',
            imgUrl      : '/images/items/J5-25.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'DW',
            type        : 'LO',
            point       : 900,
            aggregation : 'NC-J5P-23',
          }),
          item({
            collection  : 'PrettyCollection2',
            id          : 'NC-J5P-26',
            rare        : 'PR',
            name        : 'ミス・ドラマティックブルーヘアアクセ',
            imgUrl      : '/images/items/J5-26.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'DW',
            type        : 'LO',
            point       : 800,
            aggregation : 'NC-J5P-23',
          }),


          // [NOTE] ニコチケ SR プリティーコレクションその2
          // ================================================================================



        ]
      }
    },

    computed: {
    },

    methods: {
      collection (collection = '', rare = '') {
        return rare
          ? _.where(this.items, { collection, rare })
          : _.where(this.items, { collection })
      },
    },
  }
</script>


<template>
  <ItemPage :items="items" :narrowCols="[1,2,7,8,9]">

    <template #title>
      <PageChooser />
      <time>{{ date }}</time>
    </template>

    <template #col1>
      <ItemList title="プリリズDMFCh|🥚 ER 🥚" color="#44cd1f" :items="collection('PRDMFCh', 'ER')" />
      <ItemList title="プリリズDMFCh|PR ★★★" color="#ffa1bc" :items="collection('PRDMFCh', 'PR')" />
    </template>

    <template #col2>
      <ItemList title="プリリズDMFCh|SR ★★" color="#00c7da" :items="collection('PRDMFCh', 'SR')" />
      <ItemList title="プリリズDMFCh|R ★" color="#feab0d" :items="collection('PRDMFCh', 'R')" />
    </template>

    <template #col3>
      <ItemList title="ドリームパレードCh|🥚 ER 🥚" color="#44cd1f" :items="collection('DreamParadeCh', 'ER')" />
      <ItemList title="ドリームパレードCh|PR ★★★" color="#ffa1bc" :items="collection('DreamParadeCh', 'PR')" />
    </template>

    <template #col4>
      <ItemList title="ドリームパレードCh|SR ★★" color="#00c7da" :items="collection('DreamParadeCh', 'SR')" />
    </template>

    <template #col5>
    </template>

    <template #col6>
    </template>

    <template #col7>
      <ItemList title="イルミナージュコーデ|✨ IR ✨" color="#edd50f" :items="collection('ReappearIR') | first(9 * 4)" />
    </template>

    <template #col8>
      <ItemList title="イルミナージュコーデ|✨ IR ✨" color="#edd50f" :items="collection('ReappearIR') | rest(9 * 4)" :isOrphan="true" />
    </template>

    <template #col9>
      <ItemList title="ジュエルアイドルCH|JR ◆◆◆◆" color="#ff5d91" :items="collection('JewelIdolCh', 'JR')" />
    </template>

    <template #col10>
      <ItemList title="ジュエルアイドルCH|PR ★★★" color="#ffa1bc" :items="collection('JewelIdolCh', 'PR')" />
      <ItemList title="ジュエルアイドルCH|SR ★★" color="#00c7da" :items="collection('JewelIdolCh', 'SR')" />
    </template>

    <template #col11>
      <ItemList title="プリティーオールフレンズ|チャンネル" color="#feab0d" :items="collection('PAFCh') | first(10 * 4)" />
    </template>

    <template #col12>
      <ItemList title="プリティーオールフレンズ|チャンネル" color="#feab0d" :items="collection('PAFCh') | rest(10 * 4)" :isOrphan="true" />
    </template>

    <template #col13>
    </template>

    <template #col14>
      <ItemList title="パシャッとアイテム|チャンネル" color="#c598ff" :items="collection('PashaItemCh') | first(9 * 4)" />
    </template>

    <template #col15>
      <ItemList title="パシャッとアイテム|チャンネル" color="#c598ff" :items="collection('PashaItemCh') | rest(9 * 4)" :isOrphan="true" />
    </template>

    <template #col16>
      <ItemList title="プリティーコレクション2|ニコチケ PR ★★★" color="#ffa1bc" :items="collection('PrettyCollection2', 'PR') | first(9 * 4)" />
    </template>

    <template #col17>
      <ItemList title="プリティーコレクション2|ニコチケ PR ★★★" color="#ffa1bc" :items="collection('PrettyCollection2', 'PR') | rest(9 * 4)" />
      <ItemList title="プリティーコレクション2|ニコチケ SR ★★" color="#00c7da" :items="collection('PrettyCollection2', 'SR')" />
      <ItemList title="イルミナージュコーデ|✨ IR ✨" color="#edd50f" :items="itemsSuperRainbowSkyIR" />
      <Status :date="date" :items="items" :showKira="true" :showNico="true" />
    </template>

    <template #col18>
    </template>

  </ItemPage>
</template>


<style lang="scss" scoped>
  @import '~@/stylesheets/common';

  // PC View: ステータスの表示位置を調整
  .Page ::v-deep .Status {
    // PC View のとき position: absolute になっている (see: ItemPage.vue)
    bottom: 0;
    // left: $size-unit * 100;
  }

  // PC View: ステータス表示を置く空間を確保
  // @include iroha-vw-range($from: strip-unit($device-width--pc), $also-apply: print) {
  //   .Page ::v-deep .Page__body {
  //     padding-bottom: $size-unit * 20;
  //   }
  // }
</style>
